// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import infinityIcon from "@/assets/icons/infinity.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type InfinityIconProps = Omit<IconProps, "name">;

export function InfinityIcon(props: InfinityIconProps): React.ReactNode {
  return <Icon name={infinityIcon} {...props} />;
}
